import { MAIN_CURRENCY_LABEL } from '../../../consts';

export const CURRENCY = MAIN_CURRENCY_LABEL;
export const CurrencyUpper = MAIN_CURRENCY_LABEL.toUpperCase();
